import { createLayer, repaintLayers } from '../../Utils/MapUtils';
import { fromLonLat, toLonLat, transform } from 'ol/proj';
import { config } from '../../../config/Config';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Collection, Feature } from 'ol';
import { toXML } from 'to-xml';
import Polygon, { circular } from 'ol/geom/Polygon';
import { toast } from 'react-toastify';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import { getBottomLeft, getTopRight } from 'ol/extent';
import { loadLayers } from '../../Utils/APIUtils';

export async function setQueryParams(map, sitepLayers, arrayLayers, externalLayers, context) {
  const queryParams = new URLSearchParams(window.location.search);

  var layers = queryParams.get('layers');
  const disabledLayers = queryParams.get('inactive_layers');
  const stylesParam = queryParams.get('styles');
  const transparencyParam = queryParams.get('transparency');
  let styles;
  let transparency;
  let disabled = [];
  if (stylesParam) {
    styles = stylesParam.split(',').map(Number);
  }
  if (transparencyParam) {
    transparency = transparencyParam.split(',').map(Number);
  }
  if (disabledLayers) {
    disabled = disabledLayers.split(',');
  }
  let splittedLayers = layers?.split(',');

  if (splittedLayers) {
    loadLayers(layers, map, sitepLayers, arrayLayers, context);

    if (styles.length !== splittedLayers.length) {
      toast.error(getTranslatedKey('errorParamsStyles'));
    }
    if (transparency.length !== splittedLayers.length) {
      toast.error(getTranslatedKey('errorParamsTransp'));
    }

    splittedLayers.forEach((layerName, index) => {
      let sitepLayer = context.state.arrayLayers.find((lay) => lay.name === layerName);
      if (!sitepLayer) return;
      if (styles && styles[index] !== 0 && styles.length === splittedLayers.length) {
        context.state.map.removeLayer(sitepLayer.getOLLayer());
        createLayer(sitepLayer, context.state.map, context.state.arrayLayers, false, sitepLayer.getStyle(styles[index]).getName(), false);
        sitepLayer.setStyleSelected(styles[index]);
        repaintLayers(context.state.map, context.state.arrayLayers);
      }
      if (transparency && transparency[index] !== 1 && transparency.length === splittedLayers.length) {
        sitepLayer.getOLLayer().setOpacity(transparency[index]);
      }
      if (disabled.includes(layerName)) {
        sitepLayer.setVisible(false);
        sitepLayer.getOLLayer().setVisible(false);
      }
    });
  }
}

export function crearUrlParametritzada(map, arrayLayers, fons, transparenciaFons) {
  let urlParametritzada = '';
  let ext = map.getView().calculateExtent(map.getSize());
  let diagonal = [getBottomLeft(ext), getTopRight(ext)];
  diagonal[0] = transform(diagonal[0], config.EPSG_mapa, config.EPSG).map(Math.ceil);
  diagonal[1] = transform(diagonal[1], config.EPSG_mapa, config.EPSG).map(Math.floor);
  const bbox = diagonal.reduce((acc, curr) => acc.concat(curr), []).join(',');

  let capes = '';
  let styles = '';
  let transparency = '';
  let capesInactives = '';

  for (let i = 0; i < arrayLayers.length; ++i) {
    capes += capes === '' ? arrayLayers[i].getName() : ',' + arrayLayers[i].getName();
    if (!arrayLayers[i].isVisible()) capesInactives += capesInactives === '' ? arrayLayers[i].getName() : ',' + arrayLayers[i].getName();
  }

  arrayLayers.forEach((capa) => {
    styles += styles === '' ? capa.getStyleSelected() : ',' + capa.getStyleSelected();
  });

  arrayLayers.forEach((capa) => {
    transparency += transparency === '' ? capa.getOLLayer().getOpacity() : ',' + capa.getOLLayer().getOpacity();
  });

  if (fons !== undefined) {
    urlParametritzada += '?background=' + fons + '&bg_transp=' + transparenciaFons;
  }

  if (bbox !== undefined) {
    urlParametritzada += '&BBOX=' + bbox;
  }
  const queryParams = new URLSearchParams(window.location.search);
  const visorId = queryParams.get('ID');

  if (capes && capesInactives)
    urlParametritzada += '&layers=' + capes + '&styles=' + styles + '&transparency=' + transparency + '&inactive_layers=' + capesInactives;
  else if (capes) urlParametritzada += '&layers=' + capes + '&styles=' + styles + '&transparency=' + transparency;
  else if (capesInactives) urlParametritzada += '&inactive_layers=' + capesInactives;

  const url = window.location.href.split('?')[0];

  if (visorId) {
    urlParametritzada += '&ID=' + visorId;
  }

  return url + urlParametritzada;
}

export function crearMapConfig(map, arrayLayers, fons, transparenciaFons, nom, rlSource, favs) {
  let mapConf = {
    nom: nom,
    descripcio: nom,
    titol: nom,
    bbox: '',
    capaFons: '',
    capes: [],
    favoritos: [],
    map_id: null,
    redlining: '',
    transparenciaFons: '1'
  };

  //Define la BBOX del mapa
  let ext = map.getView().calculateExtent(map.getSize());
  let diagonal = [getBottomLeft(ext), getTopRight(ext)];
  // diagonal[0] = transform(diagonal[0], config.EPSG_mapa, config.EPSG_lonLat);
  // diagonal[1] = transform(diagonal[1], config.EPSG_mapa, config.EPSG_lonLat);
  // let bbox = diagonal.map((row) => row.map((coord) => coord).join(',')).join(',');
  // bbox = bbox.split(',').map(Number);
  diagonal[0] = diagonal[0].map(Math.ceil);
  diagonal[1] = diagonal[1].map(Math.floor);
  diagonal[0] = transform(diagonal[0], config.EPSG_mapa, config.EPSG_lonLat);
  diagonal[1] = transform(diagonal[1], config.EPSG_mapa, config.EPSG_lonLat);
  let bbox = diagonal.reduce((acc, curr) => acc.concat(curr), []);

  bbox = bbox[1] + ',' + bbox[0] + ',' + bbox[3] + ',' + bbox[2];
  mapConf.bbox = bbox;

  //Define la capa de fondo
  mapConf.capaFons = fons;

  //Define la transparencia de fondo
  if (transparenciaFons !== 1) {
    mapConf.transparenciaFons = Math.round(transparenciaFons * 10) / 10;
  }

  //Define el redlining
  let rlFeatures = rlSource.getFeatures();
  const transformedFeatures = [];

  rlFeatures.forEach((feat) => {
    let clonedFeature = feat.clone();
    if (clonedFeature.getGeometry().getType() === 'Circle') {
      let center = clonedFeature.getGeometry().getCenter();
      const radius = clonedFeature.getGeometry().getRadius();
      center = toLonLat(center, config.EPSG_mapa);

      let polygon = circular(center, radius);
      let circlePolConverted = polygon.getCoordinates()[0].map((coord) => {
        return fromLonLat(coord, config.EPSG);
      });
      let pol = new Polygon([circlePolConverted]);
      clonedFeature = new Feature({ geometry: pol });
      clonedFeature.setProperties({ isCircle: true, redlining: true });
    } else {
      const geom = clonedFeature.getGeometry();
      geom.transform(config.EPSG_mapa, config.EPSG);
      clonedFeature.setProperties({ redlining: true });
    }
    transformedFeatures.push(clonedFeature);
  });
  const transformedCollection = new Collection(transformedFeatures);
  const geoJSON = new GeoJSON().writeFeatures(transformedCollection.getArray());

  mapConf.redlining = geoJSON;

  // //Define los favoritos TEMPORALMENTE DESACTIVADO
  // const favArr = [];
  // favs.forEach((fav) => {
  //   if (fav.type === 'coords') {
  //     favArr.push({ capa: 'punt', feature: fav.fav.toString() });
  //   } else {
  //     let featureId = fav.fav.id_;
  //     let featureLayer = fav.layer.getName();
  //     favArr.push({ capa: featureLayer, feature: featureId });
  //   }
  // });
  // mapConf.favoritos = favArr;

  //Define las capas
  let reversedLayers = [...arrayLayers].reverse();

  let userWMS = false;

  reversedLayers.forEach((layer) => {
    if (layer.userWMS) userWMS = true;
    //Las capas de fichero las cargamos en el redlining
    if (layer.isTemporal()) {
      let fc = layer.getOLLayer().getSource().getFeatures();
      let features = new GeoJSON().readFeatures(mapConf.redlining);
      fc.forEach((feature) => {
        let clonedFeature = feature.clone();
        clonedFeature.getGeometry().transform(config.EPSG_mapa, config.EPSG);
        features.push(clonedFeature);
      });
      const transformedCollection = new Collection(features);
      const geoJSON = new GeoJSON().writeFeatures(transformedCollection.getArray());

      mapConf.redlining = geoJSON;
      return;
    }
    let layerInfo = {
      description: '',
      estil: '',
      extension: {
        Namespace: '',
        Geometry: '',
        Editable: '',
        ToolTip: '',
        MetadataUUID: '',
        Property: [],
        Id: '',
        IndexCapa: ''
      },
      hidden: '',
      nom: '',
      queried: '',
      queryable: '',
      service: '',
      titol: '',
      transp: '',
      url: ''
    };

    //Descripción de la layer
    layerInfo.description = layer.isExternal()
      ? layer.getFileName()
      : layer.getCurrentStyle() && layer.getCurrentStyle().getTitle() !== undefined && layer.getCurrentStyle().getTitle() !== layer.getTitle()
      ? layer.getCurrentStyle().getTitle()
      : layer.getAbstract() !== layer.getTitle()
      ? layer.getAbstract()
      : layer.getTitle();

    //Estilo de la layer
    let style = layer.getCurrentStyle()?.getName() || '';

    layerInfo.estil = `<StyledLayerDescriptor><NamedLayer><Name>${style}</Name></NamedLayer></StyledLayerDescriptor>`;

    //Estado de oculta o no
    layerInfo.hidden = layer.isVisible() ? '0' : '1';

    //Nombre de la layer
    layerInfo.nom = layer.getName();

    //Queried de la layer
    layerInfo.queried = !layer.hasInfoEnabled() ? '0' : '1';

    //Queriable
    layerInfo.queryable = !layer.isConsultable() ? '0' : '1';

    //Tipo de servicio
    layerInfo.service = 'WMS';

    //Título
    layerInfo.titol = layer.getTitle();

    //Transparencia
    layerInfo.transp = layer.getOLLayer().getOpacity();

    //URL para pedir la layer
    layerInfo.url = layer.getOnlineResource();

    //Extension de la layer + indexcapa

    let extensionObject = layer.getExtension();
    if (extensionObject) {
      extensionObject.IndexCapa = (reversedLayers.findIndex((lay) => lay.getName() === layer.getName()) + 1).toString();
    } else {
      let index = (reversedLayers.findIndex((lay) => lay.getName() === layer.getName()) + 1).toString();
      extensionObject = { IndexCapa: index };
    }
    let extension = { Extension: extensionObject };
    layerInfo.extension = toXML(extension, null, 0);
    mapConf.capes.push(layerInfo);
  });
  if (favs.length > 0) {
    toast.info(getTranslatedKey('infoFavs'));
  }
  if (userWMS) {
    toast.info(getTranslatedKey('infoUserWms'));
  }
  return mapConf;
}

export const downloadMap = (conf, local) => {
  let url = local ? config.url_saveMap : config.url_saveUserMap;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(conf)
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Network response was not ok.');
        }
      })
      .then(async (data) => {
        if (local) {
          const anchor = document.createElement('a');
          anchor.style.display = 'none';
          anchor.href = config.url_downloadMap + '?REQUEST=WMCVIEWER&ID=' + data;
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          removeMap(data);
          resolve();
        } else {
          toast.success(getTranslatedKey('successSaveMap'));
          resolve();
        }
      })
      .catch((error) => {
        console.error(error);
        reject();
      });
  });
};

export const removeMap = (id, userMap) => {
  const url = userMap ? '/login' + config.url_removeViewer : config.url_removeViewer;

  return new Promise((resolve, reject) => {
    fetch(url + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        if (userMap) {
          toast.success(getTranslatedKey('successDeleteMap'));
        }

        resolve();
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
